import sortPropertyModifier from './sort-property-modifier'

export default function(itemName) {
  return {
    size: 10,
    page: 0,
    sort_property: defaultSortProperty(itemName),
    sort_direction: defaultSortDirection(itemName),
  }
}

function defaultSortProperty(itemName) {
  let sortPropert = itemName
  switch (itemName) {
    case 'communication':
      sortPropert = 'contact'
      break
    case 'communicationtype':
    case 'characteristic':
    case 'unit':
    case 'city':
    case 'region':
      sortPropert = 'name'
      break
    case 'density':
      sortPropert = 'goods'
      break
    default:
      sortPropert = null
      break
  }
  return sortPropertyModifier(sortPropert)
}

function defaultSortDirection(itemName) {
  switch (itemName) {
    default:
      return 'ASC'
  }
}
